export const createIsMessageAllowed = allowedOrigin => ev => allowedOrigin.indexOf(ev.origin) >= 0;
export default createIsMessageAllowed;
